import { render, staticRenderFns } from "./Orders2.vue?vue&type=template&id=0d362cc7&"
import script from "./Orders2.vue?vue&type=script&lang=js&"
export * from "./Orders2.vue?vue&type=script&lang=js&"
import style0 from "./Orders2.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports